module.exports = __webpack_public_path__ + "static/media/texture (35).76f4e658.jpg";